import {actions} from "./Reducer"


export const getMySupplierPublicInquiriesAction = (payload) => ({
    type : actions.GET_MY_SUPPLIER_PUBLIC_INQUIREY,
    payload 
})

export const getMySupplierPublicInquirySuccessAction = (publicInquiry) => ({
    type : actions.GET_MY_SUPPLIER_PUBLIC_INQUIREY_SUCCESS , 
    payload : publicInquiry
})


export const getMySuppliersPublicInquiriesAction = (body) => ({
    type:actions.GET_MY_SUPPLIER_PUBLIC_INQUIRIES,
    payload: body
})

export const getMySupplierPublicInquiriesSuccessAction = (inquiries) => ({
    type: actions.GET_MY_SUPPLIER_PUBLIC_INQUIRIES_SUCCESS,
    payload: inquiries
})


export const filterMySupplierPublicInquiriesAction = (body) => ({
    type:actions.FILTER_MY_SUPPLIER_PUBLIC_INQUIRIES,
    payload: body
})

export const filterMySupplierPublicInquiriesSuccessAction = (inquiries) => ({
    type: actions.FILTER_MY_SUPPLIER_PUBLIC_INQUIRIES_SUCCESS,
    payload: inquiries
})



export const setMySupplierPublicInquiryIsLoading = (isLoading) => ({
    type : actions.MY_SUPPLIER_PUBLIC_INQUIREY_IS_LOADING,
    payload : isLoading
})

export const getMyPublicSupplierProposalsAction = (body) =>({
    type: actions.GET_MY_SUPPLIER_PUBLIC_PROPOSALS,
    payload: body
})

export const getMyPublicSupplierProposalsSuccessAction = (proposals) => ({
    type: actions.GET_MY_SUPPLIER_PUBLIC_PROPOSALS_SUCCESS,
    payload: proposals
})

export const getMyPublicSupplierProposalAction = (body) => ({
    type: actions.GET_MY_ARTSAN_PUBLIC_PROPOSAL,
    payload: body
})

export const getMyPublicSupplierProposalSuccessAction = (proposal) => ({
    type: actions.GET_MY_ARTSAN_PUBLIC_PROPOSAL_SUCCESS,
    payload: proposal
})

export const addMyPublicSupplierProposalAction = (body, trusted) => ({
    type: actions.ADD_PUBLIC_SUPPLIER_PROPOSAL,
    payload: body,
    trusted
})

export const addMyPublicSupplierProposalSuccessActon = (proposal) => ({
    type: actions.ADD_PUBLIC_SUPPLIER_PROPOSAL_SUCCESS,
    payload: proposal
})


export const editMyPublicSupplierProposalAction = (body, trusted) => ({
    type: actions.EDIT_PUBLIC_SUPPLIER_PROPOSAL,
    payload: body,
    trusted
}) 

export const editMyPublicSupplierProposalSuccessAction = (proposal) => ({
    type: actions.EDIT_PUBLIC_SUPPLIER_PROPOSAL_SUCCESS,
    payload: proposal
})

export const deleteMyPublicSupplierProposalAction = (body) => ({
    type: actions.DELETE_PUBLIC_SUPPLIER_PROPOSAL,
    payload: body
})

export const deleteMyPublicSupplierProposalSuccessAction = (id) => ({
    type: actions.DELETE_PUBLIC_SUPPLIER_PROPOSAL_SUCCESS,
    payload: id
})

export const setSearchValueAction = value => ({
  type : actions.SET_MY_SUPPLIER_PUBLIC_INQUIREY_SEARCH,
  payload : value
})

export const setMySupplierPublicInquiriesCountAction = (count) => ({
    type: actions.SET_MY_SUPPLIER_PUBLIC_INQUIREY_COUNT,
    payload: count
})